import { IProduct } from '@/store/ducks/products/types';

export const useViewItemList = (productList: {
  id: number;
  name: string;
  products: IProduct[];
}) => {
  if (!window.gtag || !productList) return;

  window.gtag('event', 'view_item_list', {
    item_list_id: productList.id.toString(),
    item_list_name: productList.name,
    items: productList.products.map((product: IProduct) => ({
      item_id: product.id.toString(),
      item_name: product.title,
    })),
  });
};
